import React, { useState, useEffect } from "react";
import "./testnetround.scss";
import { DateRange } from "react-date-range";
import DataTable from "./Datatable/Datatable";
import axios from "axios";
import moment from "moment";
// import { Api_Url } from "../../../utils/ApiUrl";

const TestnetRound = ({ user, tomiPrice, usdPrice, btcPrice }) => {
  const Api_Url = "https://api.dop.org";
  //   const Api_Url = "http://192.168.20.68:8000";

  const tok = localStorage?.getItem("accessToken");
  const [showcalendar, setShowCalendar] = useState(false);
  const [alllset, setalllset] = useState("1");
  const [loader, setLoader] = useState(false);
  const [transactionApiCalled, setTransactionApiCalled] = useState(false);
  const [buyersApiCalled, setBuyersApiCalled] = useState(false);

  const [orderFieldTransactions, setOrderFieldTransactions] =
    useState("transactionTime");
  const [orderDirectionTransactions, setOrderDirectionTransactions] =
    useState("-1");

  const [orderFieldBuyers, setOrderFieldBuyers] = useState(
    "externalWalletAddress"
  );
  const [orderDirectionBuyers, setOrderDirectionBuyers] = useState("-1");
  const [pageTransactions, setPageTransactions] = useState(0);
  const [pageBuyers, setPageBuyers] = useState(0);

  const [pageCountTransactions, setPageCountTransactions] = useState([]);
  const [pageCountBuyers, setPageCountBuyers] = useState([]);

  const [transactions, setTransactions] = useState([]);
  const [buyersData, setBuyersData] = useState([]);

  const [statsData, setStatsData] = useState([]);
  const [activeTab, setActiveTab] = useState("home-tab");

  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dpc, setDPC] = useState(0);
  const [epc, setEPC] = useState(0);

  const handlePageChangeTransactions = (e) => {
    const selectedPage = e.selected;

    setPageTransactions(selectedPage);
  };

  const handlePageChangeBuyers = (e) => {
    const selectedPage = e.selected;

    setPageBuyers(selectedPage);
  };

  useEffect(() => {
    if (activeTab == "home-tab") {
      getTransactionsData();
    } else if (activeTab == "profile-tab") {
      getBuyersData();
    }
  }, [
    orderDirectionBuyers,
    orderFieldBuyers,
    orderFieldTransactions,
    orderDirectionTransactions,
    startDate,
    endDate,
    activeTab,
    pageTransactions,
    pageBuyers,
  ]);

  useEffect(() => {
    DashboardStatsData();
  }, [startDate, endDate, usdPrice]);

  const getTransactionsData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/testnet/transactions?limit=10&offset=${
        pageTransactions + 1
      }`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;

    if (startDate && startDate != null) {
      dynamicQuery += `&startDate=${startDate}&endDate=${endDate}`;
    }
    if (orderFieldTransactions) {
      dynamicQuery += `&orderField=${orderFieldTransactions}&orderDirection=${orderDirectionTransactions}`;
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (res) {
        // console.log("trx data: ", res?.data?.data?.transactions);
        setTransactions(res?.data?.data?.transaction);
        setPageCountTransactions(res?.data?.data?.pages);
        setTransactionApiCalled(true);
        setLoader(false);
      })
      .catch(function (error) {
        setTransactionApiCalled(true);

        setLoader(false);
      });
  };

  const getBuyersData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/testnet/buyers?limit=10&offset=${pageBuyers + 1}`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;

    if (startDate && startDate != null) {
      dynamicQuery += `&startDate=${startDate}&endDate=${endDate}`;
    }
    if (orderFieldBuyers) {
      dynamicQuery += `&orderField=${orderFieldBuyers}&orderDirection=${orderDirectionBuyers}`;
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (res) {
        setBuyersData(res?.data?.data?.testnetBuyers);
        setPageCountBuyers(res?.data?.data?.pages);
        setBuyersApiCalled(true);
        setLoader(false);
      })
      .catch(function (error) {
        setBuyersApiCalled(true);

        setLoader(false);
      });
  };

  const DashboardStatsData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/testnet/stats`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;

    if (startDate && startDate != null) {
      dynamicQuery += `?startDate=${startDate}&endDate=${endDate}`;
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (res) {
        // console.log("trx data: ", res?.data?.data?.transactions);
        const resData = res?.data?.data;
        let dopChange = 0;

        if (
          resData?.totalDopPurchased === 0 &&
          resData?.oldTotalDopPurchased === 0
        ) {
          dopChange = 0;
        } else if (
          resData?.totalDopPurchased === 0 ||
          resData?.oldTotalDopPurchased === 0
        ) {
          if (resData?.totalDopPurchased === 0) {
            dopChange =
              ((0 - resData?.oldTotalDopPurchased) /
                resData?.oldTotalDopPurchased) *
              100;
          }
          if (resData?.oldTotalDopPurchased === 0) {
            dopChange = ((resData?.totalDopPurchased + 1 - 1) / 1) * 100;
          }
        } else {
          dopChange =
            ((resData?.totalDopPurchased - resData?.oldTotalDopPurchased) /
              resData?.oldTotalDopPurchased) *
            100;
        }

        setDPC(dopChange);

        let ethChange = 0;

        if (
          resData?.totalEthInvested === 0 &&
          resData?.oldTotalEthInvested === 0
        ) {
          ethChange = 0;
        } else if (
          resData?.totalEthInvested === 0 ||
          resData?.oldTotalEthInvested === 0
        ) {
          if (resData?.totalEthInvested === 0) {
            ethChange =
              ((0 - resData?.oldTotalEthInvested) /
                resData?.oldTotalEthInvested) *
              100;
          }
          if (resData?.oldTotalEthInvested === 0) {
            ethChange = ((resData?.totalEthInvested + 1 - 1) / 1) * 100;
          }
        } else {
          ethChange =
            ((resData?.totalEthInvested - resData?.oldTotalEthInvested) /
              resData?.oldTotalEthInvested) *
            100;
        }

        setEPC(ethChange);

        setStatsData(res?.data?.data);
      })
      .catch(function (error) {
        setTransactionApiCalled(true);

        setLoader(false);
      });
  };

  useEffect(() => {
    formatDates("1");
  }, []);

  const formatDates = (times) => {
    let date = null;
    let date1 = null;
    if (Array.isArray(times)) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).format("Y-MM-DDT00:00:00");
      date1 = moment(b).format("Y-MM-DDT23:59:59");
    } else if (times == "1") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }
    // else if (times == "seven") {
    //   var date12 = new Date();
    //   var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
    //   var myDate = new Date();
    //   myDate.setTime(myDate.getTime() - dateOffset);
    //   date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
    //   date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    // } else if (times == "year") {
    //   var date12 = new Date();
    //   var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
    //   var myDate = new Date();
    //   myDate.setTime(myDate.getTime() - dateOffset);
    //   date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
    //   date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    // } else if (times == "month") {
    //   var date12 = new Date();
    //   var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
    //   var myDate = new Date();
    //   myDate.setTime(myDate.getTime() - dateOffset);
    //   date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
    //   date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    // }
    setStartDate(date);
    setEndDate(date1);
  };

  function formatBuyersValue(buyersValue) {
    if (buyersValue >= 1000000) {
      return (buyersValue / 1000000).toFixed(3) + "M";
    } else if (buyersValue >= 1000) {
      return (buyersValue / 1000).toFixed(2) + "k";
    } else {
      return buyersValue;
    }
  }

  return (
    <>
      <section className="testnet-round">
        <div className="custom-container">
          <div className="twice-field">
            <div className="main-heading">
              <h6>Testnet Buying Stats</h6>
            </div>
            <div className="custom-tab-bar">
              <a
                className={alllset == "1" ? "active" : "noactive"}
                onClick={() => {
                  setalllset("1");

                  formatDates("1");
                }}
              >
                1D
              </a>
              <a
                className={alllset == "all" ? "active" : "noactive"}
                onClick={() => {
                  setalllset("all");

                  formatDates("");
                }}
              >
                All
              </a>
              <a onClick={() => setShowCalendar(!showcalendar)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M17.1667 3.56V2C17.1667 1.59 16.8267 1.25 16.4167 1.25C16.0067 1.25 15.6667 1.59 15.6667 2V3.5H9.16673V2C9.16673 1.59 8.82673 1.25 8.41673 1.25C8.00673 1.25 7.66673 1.59 7.66673 2V3.56C4.96673 3.81 3.65673 5.42 3.45673 7.81C3.43673 8.1 3.67673 8.34 3.95673 8.34H20.8767C21.1667 8.34 21.4067 8.09 21.3767 7.81C21.1767 5.42 19.8667 3.81 17.1667 3.56Z"
                    fill="white"
                  />
                  <path
                    d="M20.4167 9.84009H4.41675C3.86675 9.84009 3.41675 10.2901 3.41675 10.8401V17.0001C3.41675 20.0001 4.91675 22.0001 8.41675 22.0001H16.4167C19.9167 22.0001 21.4167 20.0001 21.4167 17.0001V10.8401C21.4167 10.2901 20.9667 9.84009 20.4167 9.84009ZM9.62675 18.2101C9.57675 18.2501 9.52675 18.3001 9.47675 18.3301C9.41675 18.3701 9.35675 18.4001 9.29675 18.4201C9.23675 18.4501 9.17675 18.4701 9.11675 18.4801C9.04675 18.4901 8.98675 18.5001 8.91675 18.5001C8.78675 18.5001 8.65675 18.4701 8.53675 18.4201C8.40675 18.3701 8.30675 18.3001 8.20675 18.2101C8.02675 18.0201 7.91675 17.7601 7.91675 17.5001C7.91675 17.2401 8.02675 16.9801 8.20675 16.7901C8.30675 16.7001 8.40675 16.6301 8.53675 16.5801C8.71675 16.5001 8.91675 16.4801 9.11675 16.5201C9.17675 16.5301 9.23675 16.5501 9.29675 16.5801C9.35675 16.6001 9.41675 16.6301 9.47675 16.6701C9.52675 16.7101 9.57675 16.7501 9.62675 16.7901C9.80675 16.9801 9.91675 17.2401 9.91675 17.5001C9.91675 17.7601 9.80675 18.0201 9.62675 18.2101ZM9.62675 14.7101C9.43675 14.8901 9.17675 15.0001 8.91675 15.0001C8.65675 15.0001 8.39675 14.8901 8.20675 14.7101C8.02675 14.5201 7.91675 14.2601 7.91675 14.0001C7.91675 13.7401 8.02675 13.4801 8.20675 13.2901C8.48675 13.0101 8.92675 12.9201 9.29675 13.0801C9.42675 13.1301 9.53675 13.2001 9.62675 13.2901C9.80675 13.4801 9.91675 13.7401 9.91675 14.0001C9.91675 14.2601 9.80675 14.5201 9.62675 14.7101ZM13.1267 18.2101C12.9367 18.3901 12.6767 18.5001 12.4167 18.5001C12.1567 18.5001 11.8967 18.3901 11.7067 18.2101C11.5267 18.0201 11.4167 17.7601 11.4167 17.5001C11.4167 17.2401 11.5267 16.9801 11.7067 16.7901C12.0767 16.4201 12.7567 16.4201 13.1267 16.7901C13.3067 16.9801 13.4167 17.2401 13.4167 17.5001C13.4167 17.7601 13.3067 18.0201 13.1267 18.2101ZM13.1267 14.7101C13.0767 14.7501 13.0267 14.7901 12.9767 14.8301C12.9167 14.8701 12.8567 14.9001 12.7967 14.9201C12.7367 14.9501 12.6767 14.9701 12.6167 14.9801C12.5467 14.9901 12.4867 15.0001 12.4167 15.0001C12.1567 15.0001 11.8967 14.8901 11.7067 14.7101C11.5267 14.5201 11.4167 14.2601 11.4167 14.0001C11.4167 13.7401 11.5267 13.4801 11.7067 13.2901C11.7967 13.2001 11.9067 13.1301 12.0367 13.0801C12.4067 12.9201 12.8467 13.0101 13.1267 13.2901C13.3067 13.4801 13.4167 13.7401 13.4167 14.0001C13.4167 14.2601 13.3067 14.5201 13.1267 14.7101ZM16.6267 18.2101C16.4367 18.3901 16.1767 18.5001 15.9167 18.5001C15.6567 18.5001 15.3967 18.3901 15.2067 18.2101C15.0267 18.0201 14.9167 17.7601 14.9167 17.5001C14.9167 17.2401 15.0267 16.9801 15.2067 16.7901C15.5767 16.4201 16.2567 16.4201 16.6267 16.7901C16.8067 16.9801 16.9167 17.2401 16.9167 17.5001C16.9167 17.7601 16.8067 18.0201 16.6267 18.2101ZM16.6267 14.7101C16.5767 14.7501 16.5267 14.7901 16.4767 14.8301C16.4167 14.8701 16.3567 14.9001 16.2967 14.9201C16.2367 14.9501 16.1767 14.9701 16.1167 14.9801C16.0467 14.9901 15.9767 15.0001 15.9167 15.0001C15.6567 15.0001 15.3967 14.8901 15.2067 14.7101C15.0267 14.5201 14.9167 14.2601 14.9167 14.0001C14.9167 13.7401 15.0267 13.4801 15.2067 13.2901C15.3067 13.2001 15.4067 13.1301 15.5367 13.0801C15.7167 13.0001 15.9167 12.9801 16.1167 13.0201C16.1767 13.0301 16.2367 13.0501 16.2967 13.0801C16.3567 13.1001 16.4167 13.1301 16.4767 13.1701C16.5267 13.2101 16.5767 13.2501 16.6267 13.2901C16.8067 13.4801 16.9167 13.7401 16.9167 14.0001C16.9167 14.2601 16.8067 14.5201 16.6267 14.7101Z"
                    fill="white"
                  />
                </svg>
              </a>
              {showcalendar && (
                <div className="cal set-custom-calendar-div">
                  <DateRange
                    editableDateInputs={true}
                    moveRangeOnFirstSelection={false}
                    ranges={state}
                    onChange={(item) => {
                      setState([item.selection]);
                      formatDates([item.selection]);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="bottom-cards">
            <div className="single-card">
              <img
                src="\assets\dashboard\noofpurchases.svg"
                alt="img"
                className="img-fluid"
              />
              <p>Testnet Eligible Buyers</p>
              <h6>{parseInt(statsData?.eligibleCount)?.toLocaleString()}</h6>
            </div>
            <div className="single-card">
              <img
                src="\assets\dashboard\noofpurchases.svg"
                alt="img"
                className="img-fluid"
              />
              <p>Testnet Buyers</p>
              <h6>{formatBuyersValue(statsData?.testnetBuyersCount)}</h6>
            </div>
            <div className="single-card set-custom-widthflex">
              <img
                src="\assets\doppurchased.svg"
                alt="img"
                className="img-fluid"
              />
              <p>DOP Purchased</p>
              <h6>
                {parseFloat(statsData?.totalDopPurchased)
                  ?.toFixed(2)
                  ?.toLocaleString()}{" "}
                DOP{" "}
                <span className={dpc > 0 ? "green-text" : "red-text ms-2"}>
                  {dpc ? dpc.toFixed(1) + "% " : ""}
                </span>
              </h6>
            </div>
            <div className="single-card set-custom-widthflex">
              <img
                src="\assets\purchasedamount.svg"
                alt="img"
                className="img-fluid"
              />
              <p>Purchased Amount</p>
              <h6>
                ~$
                {parseFloat(
                  (statsData?.totalEthInvested || 0) * (usdPrice || 0)
                )
                  ?.toFixed(2)
                  ?.toLocaleString()}{" "}
                <span className={dpc > 0 ? "green-text" : "red-text ms-2"}>
                  {epc ? epc.toFixed(1) + "% " : ""}
                </span>
              </h6>
              <p style={{ marginTop: "10px" }}>
                {parseFloat(statsData?.totalEthInvested)
                  ?.toFixed(5)
                  ?.toLocaleString()}{" "}
                ETH
              </p>
            </div>
            <div className="single-card set-custom-widthflex">
              <img
                src="\assets\avgperuser.svg"
                alt="img"
                className="img-fluid"
              />
              <p>Average Per User</p>
              <h6>
                ~$
                {parseFloat((statsData?.averageEarnings || 0) * (usdPrice || 0))
                  ?.toFixed(2)
                  ?.toLocaleString()}{" "}
                {/* <span className={dpc > 0 ? "green-text" : "red-text ms-2"}>
                  {epc ? epc.toFixed(1) + "% " : ""}
                </span> */}
              </h6>
              <p style={{ marginTop: "10px" }}>
                {parseFloat(statsData?.averageEarnings)
                  ?.toFixed(5)
                  ?.toLocaleString()}{" "}
                ETH
              </p>
            </div>
          </div>
          <DataTable
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            transactions={transactions}
            transactionApiCalled={transactionApiCalled}
            buyersData={buyersData}
            buyersApiCalled={buyersApiCalled}
            orderDirectionBuyers={orderDirectionBuyers}
            orderFieldBuyers={orderFieldBuyers}
            orderDirectionTransactions={orderDirectionTransactions}
            orderFieldTransactions={orderFieldTransactions}
            setOrderDirectionBuyers={setOrderDirectionBuyers}
            setOrderFieldBuyers={setOrderFieldBuyers}
            setOrderDirectionTransactions={setOrderDirectionTransactions}
            setOrderFieldTransactions={setOrderFieldTransactions}
            handlePageChangeTransactions={handlePageChangeTransactions}
            handlePageChangeBuyers={handlePageChangeBuyers}
            pageCountBuyers={pageCountBuyers}
            pageCountTransactions={pageCountTransactions}
            pageBuyers={pageBuyers}
            pageTransactions={pageTransactions}
          />
        </div>
      </section>
    </>
  );
};

export default TestnetRound;
